<template>
  <div class="pre-complete-modal text-center">
    <template>
      <h2 class="white">You already used the Recommender button once. Are you sure you want to use it again?</h2>
      <div class="buttons flex justify-content-around margin-top">
        <button class="bg-sunset-orange" @click="$emit('confirmRecommender')">Yes</button>
        <button class="bg-dark-blue" @click="$emit('close')">Cancel</button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'RecommenderModal'
}
</script>

<style lang="less" scoped>
.pre-complete-modal {
  &.second {
    margin-right: -20px;
    margin-left: -20px;
  }

  .warning-icon {
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    padding: 10px;
    border-radius: 50%;
    background: #F2F2F2;
    line-height: 60px;
    border: 2px solid #FFF;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .buttons {
    button {
      border-radius: 6px;
      box-shadow: 0px 3px 6px 0px rgba(0,0,0,.2);
    }
  }
}
</style>
